import React from "react";

export default function TicketCommentAttachment16({ color, className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
      focusable="false"
    >
      <path
        d="M8.66667 1.33398H4C3.64638 1.33398 3.30724 1.47446 3.05719 1.72451C2.80714 1.97456 2.66667 2.3137 2.66667 2.66732V13.334C2.66667 13.6876 2.80714 14.0267 3.05719 14.2768C3.30724 14.5268 3.64638 14.6673 4 14.6673H12C12.3536 14.6673 12.6928 14.5268 12.9428 14.2768C13.1929 14.0267 13.3333 13.6876 13.3333 13.334V6.00065L8.66667 1.33398Z"
        fill={color}
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66667 1.33398V6.00065H13.3333"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
